import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const NotFound = styled.div`  
width: 100%;
height: calc(100vh - 15em); 
text-align: center;
vertical-align: center;
font-size: 18px;
padding-top: 25%;
color: ${colors.greyscale.dark_grey};

`;